module.exports = __webpack_public_path__ + "img/united.6c464225.png";